'use client';

import {
  buildEventProperties,
  NonSegmentEvents,
  SegmentEvents,
  trackD2CNonSegmentAnalytics,
  trackD2CSegmentAnalytics,
  UserBrowser,
} from '@/analytics';
import { AnalyticsExtras } from '@/analytics/AnalyticsExtras';
import { getFullStorySessionURL } from '@/utils/fullStory-utils';
import {
  Checkbox,
  type CheckboxProps,
} from '@asurion-core/mx-asurion-ui-react';
import { ProductType } from '@sales-domain/product-config';
import clsx from 'clsx';
import { useParams, usePathname } from 'next/navigation';
import { useState } from 'react';
import { SMSOptInCheckboxLabel } from './SMSOptInCheckboxLabel';

type SMSOptInCheckboxProps = Omit<CheckboxProps, 'label' | 'checked'> & {
  productSku?: string;
};

export function SMSOptInCheckbox({
  onChange,
  productSku,
  ...rest
}: SMSOptInCheckboxProps) {
  const [checked, setChecked] = useState(false);
  const params = useParams();
  const pathname = usePathname();
  const paths = pathname.split('/').filter((path) => path !== '');

  return (
    <Checkbox
      checked={checked}
      label={<SMSOptInCheckboxLabel />}
      {...rest}
      className={clsx(rest.className, '!items-start')}
      onChange={(e) => {
        if (e.target.checked) {
          trackD2CNonSegmentAnalytics(
            NonSegmentEvents.SmsOptIn,
            buildEventProperties({
              event: NonSegmentEvents.SmsOptIn,
              extraData: {
                productUrlSlug: params.product,
                partnerUrlSlug: params.partner,
                presentationUrlSlug: paths[paths.length - 2] ?? '',
              },
            }),
          );
        }

        // analytic events to track SMS Opt In
        AnalyticsExtras.get().smsOptIn = e.target.checked;
        trackD2CSegmentAnalytics(SegmentEvents.OrderUpdated, {
          Name: SegmentEvents.OrderUpdated,
          Scope: 'd2c-sales-tool',
          Time: new Date().toISOString(),
          ExtraData: {
            FullstorySession: getFullStorySessionURL(),
            SmsOptIn: e.target.checked,
            eventName: SegmentEvents.OrderUpdated,
            products: [
              {
                productSku: productSku ?? '',
                productId: '',
                sku: productSku ?? '',
                category: ProductType.ConnectedHome,
                name: '',
                brand: '',
                quantity: 1,
                price: 0,
              },
            ],
            properties: {
              correlationId: '',
              affiliation: 'DigitalEnrollment',
              orderId: '',
              total: 0,
              isEnrolled: 0,
              products: [
                {
                  quantity: 1,
                },
              ],
              currency: 'USD',
            },
          },
          Identities: {
            UserBrowserId: UserBrowser.get().UserBrowserId,
          },
          MetaData: {
            HostApp: 'd2c-sales-tool',
            SourceApp: 'd2c-sales-tool',
            Client: UserBrowser.Partner,
          },
        });
        setChecked(e.target.checked);
        onChange?.(e);
      }}
    />
  );
}
